import { render, staticRenderFns } from "./BookmarkForm.vue?vue&type=template&id=3575191c&scoped=true"
import script from "./BookmarkForm.vue?vue&type=script&lang=js"
export * from "./BookmarkForm.vue?vue&type=script&lang=js"
import style0 from "./BookmarkForm.vue?vue&type=style&index=0&id=3575191c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575191c",
  null
  
)

export default component.exports